import { isValidOutput, isValidRecursiveQuestion } from "./blockValidation";
import checkIfBlockIsVisible from "./checkIfBlockIsVisible";
import checkIfStepIsVisible from "./checkIfStepIsVisible";

const filterActiveSteps = (context) => {
  const { data } = context;
  return data
    .filter((step) => {
      return (
        checkIfStepIsVisible(step, context, true) &&
        (step?.output?.length || step.recursiveQuestions?.length)
      );
    })
    .map((step) => {
      const blocks = step.blocks.filter(
        (b) =>
          (isValidOutput(b) || isValidRecursiveQuestion(b, context)) &&
          checkIfBlockIsVisible(b, context)
      );

      return {
        ...step,
        blocks,
      };
    })
    .filter((step) => step.blocks.length);
};

export default filterActiveSteps;
